module.exports = __webpack_public_path__ + "img/reportExcel.2fed997a.svg";